"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiRadio = function MuiRadio(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.grey[400],
      '&.Mui-checked svg:first-child': {
        color: theme.palette.grey[400]
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabledBackground
      }
    }
  };
};

var _default = MuiRadio;
exports["default"] = _default;